import { useState, useCallback } from 'react';

const STORAGE_KEY = 'project-controlling-prefs';

const defaultPrefs = {
  visibleMetrics: ['orderVolume', 'openBillable'],
};

function loadPrefs() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? { ...defaultPrefs, ...JSON.parse(stored) } : defaultPrefs;
  } catch {
    return defaultPrefs;
  }
}

function savePrefs(prefs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

export const metricOptions = [
  { key: 'orderVolume', labelKey: 'Order Volume' },
  { key: 'invoiced', labelKey: 'Invoiced' },
  { key: 'openBillable', labelKey: 'Time Billing (open)' },
  { key: 'openBillableHours', labelKey: 'Open Billable Hours' },
  { key: 'billableByProgress', labelKey: 'Performance Billing (open)' },
  { key: 'remainingVolume', labelKey: 'Remaining Volume' },
  { key: 'deadline', labelKey: 'Deadline' },
];

const useControllingPreferences = () => {
  const [prefs, setPrefs] = useState(loadPrefs);

  const toggleMetric = useCallback((key) => {
    setPrefs((prev) => {
      const metrics = prev.visibleMetrics.includes(key)
        ? prev.visibleMetrics.filter((m) => m !== key)
        : [...prev.visibleMetrics, key];
      const next = { ...prev, visibleMetrics: metrics };
      savePrefs(next);
      return next;
    });
  }, []);

  return { prefs, toggleMetric };
};

export default useControllingPreferences;
